import { Pagination } from '~/components/Pagination/Pagination';
import { usePersonListQuery } from '~/pages/person/queries';
import { PersonSerializerResponse } from '~/apis/ssf';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { querySchema } from '../query-schema';
import { Fragment } from 'react/jsx-runtime';

function Row({ person }: { person: PersonSerializerResponse }) {
  return (
    <Table.Row>
      <Table.Col>
        <Link to={`/lifters/${person.id}`}>
          {person.first_name} {person.last_name}
        </Link>
      </Table.Col>
      <Table.Col>
        <Link to={`/clubs/${person.club.id}`}>{person.club.name}</Link>
      </Table.Col>
      <Table.Col>
        <Link to={`/districts/${person.club.district.id}`}>{person.club.district.name}</Link>
      </Table.Col>
    </Table.Row>
  );
}

export function LifterListTable() {
  const { values } = useFilterForm(querySchema.parse);

  const { data, isLoading } = usePersonListQuery({
    page_size: values.pageSize,
    page: values.pageIndex,
    search: values.search,
    club: values.club,
    district: values.district,
    ordering: 'first_name',
  });

  return (
    <Fragment>
      <Table bg="even">
        <Table.Head>
          <Table.Row>
            <Table.Col as="th">Namn</Table.Col>
            <Table.Col as="th">Förening</Table.Col>
            <Table.Col as="th">Distrikt</Table.Col>
          </Table.Row>
        </Table.Head>

        <Table.Body>
          {isLoading ? (
            <Table.Loading cols={3} />
          ) : (
            data?.results.map(person => <Row key={person.id} person={person} />)
          )}
        </Table.Body>
      </Table>

      <Pagination count={data?.count} />
    </Fragment>
  );
}
